var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.599
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.477,8.76v6.481c0,1.04.555,2.001,1.455,2.521l5.613,3.24c.901.52,2.01.52,2.911,0l5.613-3.24c.901-.52,1.455-1.481,1.455-2.521v-6.481c0-1.04-.555-2.001-1.455-2.521l-5.613-3.24c-.901-.52-2.01-.52-2.911,0l-5.613,3.24c-.901.52-1.455,1.481-1.455,2.521Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b9b5cc71ae39104343737f726e1372ff.svg";
export { ForwardRef as ReactComponent };